import i18next from 'i18next';

i18next.addResources('es', 'projectsSearchModule', {
  search: 'Buscar',
  filter: 'Filtrar',
  filterBy: 'Filtrar por',
  apply: 'Aplicar',
  searchPlaceholder: 'Encuentra proyectos...'
});
